import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowSpaceBetween: {
        justifyContent: "space-between",
        flexDirection: "row"
    },
    rowContainer2: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    rowContainer: {
        flexDirection: "row"
    },
    borderedCard: {
        borderRadius: 12
    },
    borderedCard2: {
        borderRadius: 8
    },
    borderedCard3: {
        borderRadius: 8
    },
    borderedCard4: {
        borderRadius: 8
    },
    borderedCard5: {
        borderRadius: 8
    },
    borderedCard6: {
        borderRadius: 8
    }
});
export default stylesheet;
